const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
};

const chartJsTooltipRemove = () => {
  const chartJsObj = document.querySelector("#chartjs-tooltip");
  chartJsObj && (chartJsObj.remove());
}

export { scrollToTop, chartJsTooltipRemove }